import 'bootstrap/dist/css/bootstrap.min.css';
import React, { Component } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Spinner from 'react-bootstrap/Spinner';

import { Route, Routes } from 'react-router-dom';
import './App.css';
import API from './components/api/API';
import ManualLauncher from './components/Manual/ManualLauncher';
import Game from './components/Game/Game';
import GamePage from './components/Pages/GamePage';
import LobbiesPage from './components/Pages/LobbiesPage';
import SavesPage from './components/Pages/SavesPage';
import SkinComponent from './components/Library/SkinComponent';
import MainMenuShell from './components/Menus/MainMenu/MainMenuShell';
import LobbyDestroyedModal from './components/Menus/LobbyDestroyedModal';
import OwnerDisconnectedModal from './components/Menus/OwnerDisconnectedModal';
import PeerLeftModal from './components/Menus/Lobby/PeerLeftModal';
import SeatRequestModal from './components/Menus/Lobby/SeatRequestModal';
import TabKickedModal from './components/Menus/TabKickedModal';
import LoginForm from './components/PlayerManagement/LoginForm';
import NewUserRegistration from './components/PlayerManagement/NewUserRegistration';
import UpgradeAccountForm from './components/PlayerManagement/UpgradeAccountForm';
import TokenedPasswordResetForm, { PasswordResetForm } from './components/PlayerManagement/PasswordReset';
// Restored 2026-05-26: email verification is back.
import RegistrationResponse from './components/PlayerManagement/RegistrationResponse';
import { APPLICATION_TITLE } from './Constants';
import { DiscordBootPanel } from './discord/DiscordBootPanel';
import { DiscordLobbyNavigator } from './discord/DiscordLobbyNavigator';
import { DiscordProvider } from './discord/DiscordProvider';
import './hsh.css';

// Re-exported so callers (including tests) can pick up the navigator
// off App.js as a named import even though its implementation lives
// in its own module — App.js's import graph is too heavy to load
// inside a focused unit test.
export { DiscordLobbyNavigator };
export { DiscordBootPanel };

// Lazy-loaded so the d3 bundle and the rest of the HSHM Operations
// console code never ship to non-staff users. See
// src/pages/zhsh_console/ZhshConsoleShell.js for the route guard.
const ZhshConsoleShell = React.lazy(() =>
    import('./pages/zhsh_console/ZhshConsoleShell')
);

// Rankings & player profile are player-facing routes that pull in the
// d3 chart bundle, so they're lazy-loaded the same way the staff
// console is — the charts never ship to users who don't visit a
// rankings/profile route. The profile page lives at its own top-level
// route (reached by clicking a leaderboard row), not as a tab.
const RankingsShell = React.lazy(() =>
    import('./pages/rankings/RankingsShell')
);
const PlayerProfilePage = React.lazy(() =>
    import('./pages/rankings/PlayerProfilePage')
);
// `/profile` is a thin redirect to `/players/:currentUserId` so the
// existing PlayerProfilePage handles the actual rendering. Lazy-loaded
// alongside the rest of the rankings bundle.
const ProfileRedirect = React.lazy(() =>
    import('./pages/rankings/ProfileRedirect')
);

// In-app HSHM Rule Book reader. Public surface (reachable from both
// authenticated and unauthenticated states); lazy-loaded so the
// react-markdown bundle never ships to users who don't visit it.
const ManualPage = React.lazy(() =>
    import('./components/Manual/ManualPage')
);


// function NotFound() {
//     return <div>App - 404 - Not Found -- <Link to="/">Home</Link></div>
// }

class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: false,
            forceLogout: false,
            authenticator: null,
            searchResults: [],
            searchValue: '',
            authenticating: true,
            privacyMode: false,
            experience: {},
            next: null,
            cart: {
                uuid: null,
                cartitem_set: []
            },
            listData: {},
            gameId: null,
            backToMyProfile: false,
            startMainScene: false,
            start2d: false
        };

        this.forceLogoutButton = this.forceLogoutButton.bind(this);
        this.onLogin = this.onLogin.bind(this);
        this.onAuthenticationLost = this.onAuthenticationLost.bind(this);
        this.onIsAuthenticated = this.onIsAuthenticated.bind(this);

        this.gameComponent = null;
        this.gameController = null;
        this.playerProfile = null;
        this.menuController = null;
        this.ftueController = null;
        this.friendsMenu = null;
        this.bottomMenu = null;
        this.groupMenu = null;
        this.connectionMenu = null;

        this.game = null;

    }

    componentDidMount() {
        this.instantiateAuthenticator();
    }

    instantiateAuthenticator = () => {
        if (this.state.authenticator) {
            this.state.authenticator.stop();
        }
        const authenticator = new API(
            this,
            this.onAuthenticationLost,
            this.onIsAuthenticated);
        this.setState({
            authenticator: authenticator
        });
    };

    onAuthenticationLost = () => {
        this.setState({
            isAuthenticated: false,
            authenticating: false
        });
    };

    onLogin(event, loginFormState) {
        const username = loginFormState.username;
        const password = loginFormState.password;
        this.state.authenticator.login(username, password);
    }

    onIsAuthenticated = () => {
        if (!this.game) {
            this.game = new Game(this);
        }
        const privacyMode = false;  // this.state.authenticator.account.privacy_mode || false;
        const cart = this.state.cart;  // this.state.authenticator.account.cart || this.state.cart;
        this.setState({
            isAuthenticated: true,
            authenticating: false,
            privacyMode: privacyMode,
            cart: cart
        });
    };

    forceLogoutButton(event) {
        const logoutPromise = this.state.authenticator.logout();
        this.setState({
                isAuthenticated: false
            }
        );
        return logoutPromise;
    }

    reconnectButton = (event) => {
        this.state.authenticator.socketHandler.reconnect();
        if (this.gameController) {
            this.gameController.reconnectToGame();
        }
    }

    getSkin() {
        if (this.state.authenticator.account &&
            this.state.authenticator.account.selected_skin) {
            let skinId = this.state.authenticator.account.selected_skin;
            if (this.gameController.library && this.gameController.library.skinLibrary) {
                let skin = this.gameController.library.skinLibrary.skins[skinId];
                if (skin) {
                    let css = skin.css;
                    return <style>{css}</style>
                }
            }
        }
        return <></>
    }

    render() {
        console.log('App', this.state);
        document.title = APPLICATION_TITLE;
        if (!this.state.authenticator || this.state.authenticating) {
            return (<DiscordProvider app={this}><DiscordBootPanel /><Spinner animation="border" variant="primary"
                             role="status">
                <span className="sr-only">Checking Authentication...</span>
            </Spinner></DiscordProvider>);
        }

        // TODO: reapply https enforcement.
        // const url = window.location.origin;
        // if (!url.includes('localhost') && !url.includes('https')) {
        //     window.location = `https:${url.split(':')[1]}`
        // }
        console.log('App.render', this.state);
        let bypassAuth = false;

        if (!bypassAuth && !this.state.isAuthenticated && !!this.state.authenticator && !this.state.authenticating) {
            return (<DiscordProvider app={this}><DiscordBootPanel /><div role={'main'}
                         aria-label={'main-app'}
                         ref={appElement => {
                             this.appElement = appElement;
                         }}
                >
                    {/*<PublicMenu authenticator={this.state.authenticator}/>*/}
                    <ManualLauncher />
                    <Routes>

                        {/* Phase 4 / anon-accounts (2026-04-13): the
                            /register/:token email-verification callback
                            was removed when registration went
                            instant-active.
                            Restored 2026-05-26: email verification is
                            back — POST /api/user_registration/ sends a
                            verification email, and /register/:token
                            mounts RegistrationResponse which POSTs the
                            token to /api/user_registration_confirm/. */}

                        <Route path="/register/:token" element={
                            <RegistrationResponse
                                {...this.props}
                                authenticator={this.state.authenticator}
                            />
                        }
                        />

                        <Route path="/register" element={
                            <NewUserRegistration
                                {...this.props}
                                authenticator={this.state.authenticator}
                            />
                        }
                        />

                        <Route exact path="/reset-password/:token"
                               element={<TokenedPasswordResetForm
                                   {...this.props}
                                   authenticator={this.state.authenticator}
                               />
                               }

                        />

                        <Route path="/reset-password"
                               element={<PasswordResetForm
                                   {...this.props}
                                   authenticator={this.state.authenticator}
                               />
                               }
                        />

                        <Route path="/manual" element={
                            <React.Suspense fallback={
                                <div className="manual-loading">Loading…</div>
                            }>
                                <ManualPage />
                            </React.Suspense>
                        }/>
                        <Route path="/manual/:slug" element={
                            <React.Suspense fallback={
                                <div className="manual-loading">Loading…</div>
                            }>
                                <ManualPage />
                            </React.Suspense>
                        }/>

                        <Route path={'*'}
                               element={<LoginForm
                                   authenticator={this.state.authenticator}/>}
                        />

                    </Routes>
                    <div style={{ marginBottom: '3.6rem' }}/>
                    <Navbar fixed="bottom" bg="light">
                        <Nav style={{ width: '100%', paddingLeft: '1rem' }}>
                            <Nav.Item style={{ width: '100%' }}>
                                @{`${APPLICATION_TITLE}`}
                            </Nav.Item>
                        </Nav>
                    </Navbar>

                </div></DiscordProvider>
            );

        }

        if (bypassAuth || this.state.isAuthenticated) {


            return <DiscordProvider app={this}><DiscordBootPanel /><div id={'app-root'} className={'app-root'}>
                <SkinComponent app={this} />
                <DiscordLobbyNavigator />
                <LobbyDestroyedModal app={this} />
                <PeerLeftModal app={this} />
                <SeatRequestModal app={this} />
                <OwnerDisconnectedModal app={this} />
                <TabKickedModal app={this} />
                <ManualLauncher />
                <Routes>
                {/* CC_FE_PAGES (2026-06-01): four-page route surface
                    matching the one-row-per-user model. /game/:lobbyUuid
                    is the single canonical "in a game" URL (GamePage
                    branches FORMING→Lobby vs PLAYING→board); /lobbies is
                    the picker; /saves is the resumable-games page. The
                    legacy /game and /game/:gameId (board-only) routes are
                    replaced by /game/:lobbyUuid; /play, /casual,
                    /play/casual and bare /lobby no longer mount a Lobby
                    surface — they fall through to the Main Menu shell. */}
                <Route path="lobbies"
                       element={<LobbiesPage app={this}/>}
                />
                <Route path="saves"
                       element={<SavesPage app={this}/>}
                />
                <Route path="game/:lobbyUuid"
                       element={<GamePage app={this}/>}
                />

                <Route path="upgrade"
                       element={<UpgradeAccountForm
                                 authenticator={this.state.authenticator}/>}
                />

                <Route path="zhsh_console/*" element={
                    <React.Suspense fallback={
                        <div className="zhsh-loading">Loading…</div>
                    }>
                        <ZhshConsoleShell app={this} />
                    </React.Suspense>
                }/>

                <Route path="rankings/*" element={
                    <React.Suspense fallback={
                        <div className="rankings-loading">Loading…</div>
                    }>
                        <RankingsShell app={this} />
                    </React.Suspense>
                }/>

                <Route path="players/:userId" element={
                    <React.Suspense fallback={
                        <div className="rankings-loading">Loading…</div>
                    }>
                        <PlayerProfilePage app={this} />
                    </React.Suspense>
                }/>

                <Route path="profile" element={
                    <React.Suspense fallback={
                        <div className="rankings-loading">Loading…</div>
                    }>
                        <ProfileRedirect app={this} />
                    </React.Suspense>
                }/>

                <Route path="manual" element={
                    <React.Suspense fallback={
                        <div className="manual-loading">Loading…</div>
                    }>
                        <ManualPage />
                    </React.Suspense>
                }/>
                <Route path="manual/:slug" element={
                    <React.Suspense fallback={
                        <div className="manual-loading">Loading…</div>
                    }>
                        <ManualPage />
                    </React.Suspense>
                }/>

                <Route path="*" element={
                    <MainMenuShell app={this} />
                }/>
            </Routes>
            </div></DiscordProvider>;
        }

    }
}

export default App;

